import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormV2ComponentsModule } from 'src/app/shared/forms-v2/form-v2.module';
import { MaterialModule } from 'src/app/shared/modules/material/material-module.module';
import { ThemedPipe } from 'src/app/shared/pipes/themed.pipe';
import { AgentLoginComponent } from './pages/agent-login/agent-login.component';
import { RecoveryCodeComponent } from './pages/forgot-password/components/recovery-code/recovery-code.component';
import { RecoveryEmailComponent } from './pages/forgot-password/components/recovery-email/recovery-email.component';
import { RecoveryNewPasswordComponent } from './pages/forgot-password/components/recovery-new-password/recovery-new-password.component';
import { RecoverySuccessComponent } from './pages/forgot-password/components/recovery-success/recovery-success.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { OneTimeLinkComponent } from './pages/one-time-link/one-time-link.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SignupComponent } from './pages/signup/signup.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { RootRoutingModule } from './root-routing.module';
import { RootComponent } from './root.component';

@NgModule({
  declarations: [
    ForgotPasswordComponent,
    LoginComponent,
    ResetPasswordComponent,
    SignupComponent,
    RootComponent,
    RecoveryEmailComponent,
    RecoveryCodeComponent,
    RecoveryNewPasswordComponent,
    RecoverySuccessComponent,
    VerifyComponent,
    OneTimeLinkComponent,
    AgentLoginComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RootRoutingModule,
    FormV2ComponentsModule,
    TranslateModule,
    ThemedPipe,
  ],
})
export class RootModule {}
